<template>
	<div class="cart-card-fast-checkout">
		<Select
			class="cart-card-fast-checkout__select"
			:label="$t('companion.keycardHeading')"
			:lightTheme="true"
			:option-items="[
				{
					id: 'new',
					text:
						'Nytt keycard (' +
						convertPrice(product.keycardPrice) +
						' ' +
						cart.currency +
						')'
				},
				{ id: 'existing', text: 'Befintligt keycard' }
			]"
			:value="
				product.keynumber
					? 'existing'
					: showExistingKeycard
					? 'existing'
					: 'new'
			"
			@input="onChangeKeycardType"
		/>

		<template v-if="product.keynumber ? false : showNewKeycard">
			<p v-html="$t('cart.newKeycardInfo')"></p>
		</template>

		<template v-if="product.keynumber ? true : showExistingKeycard">
			<!-- Key number input -->
			<InputComponent
				class="cart-card-fast-checkout__input"
				:defaultValue="product.keynumber"
				:id="product.uniqueId"
				:label="$t('companion.keycardInputLabel')"
				:placeholderValue="$t('companion.keycardInputText')"
				:type="'tel'"
				:lightTheme="true"
				:hasError="showKeycardError || showKeycardScanError && !showKeycardScan"
				:isValid="showKeycardSuccess"
				v-model="keynumber"
				ref="keycardInputComponent"
			></InputComponent>
			<!-- @input-enter="retry()" -->

			<!-- Keycard scan trigger -->
			<button 
				type="button"  
				:class="[
					'cart-card-fast-checkout__keycard-scan',
					showKeycardScan ? `--active` : ''
				]" 
				@click="showKeycardScan = true"
				:title="$t('skipass.scanningFailed')"
			>
				<svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><circle class="cls-1" cx="9" cy="11" r="3"/><path class="cls-1" d="M17.001 3h-3V2a2 2 0 00-2-2H6a2 2 0 00-2 2v1h-1A3.002 3.002 0 000 5.999V16A3.002 3.002 0 002.999 19H17A3.002 3.002 0 0020 16.001V6A3.002 3.002 0 0017.001 3zM8 2h2.002a1 1 0 110 2H7.999a1 1 0 110-2zM9 16c-2.757 0-5-2.244-5-5 0-2.757 2.243-5 5-5s5 2.243 5 5c0 2.756-2.243 5-5 5zm7.5-8a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"/></svg>
			</Button>

			<!-- Keycard number scanning error text -->
			<p v-if="!showKeycardScan && showKeycardScanError" class="keycard-error">
				{{ $t('skipass.scanningFailed') }}
			</p>

			<!-- Key number error text -->
			<p v-if="showKeycardError" class="error">
				{{ $t('companion.keycardError') }}
			</p>

			<!-- Keycard scanner -->
			<div v-if="showKeycardScan" class="keycard-scanner">
				<ScanKeycard 
					v-if="showKeycardScan"
					@keycard-scanned="
						val => {
							onKeycardScanned(val)
						}
					"
				></ScanKeycard>
			</div>

			<!-- Validation -->
			<Button
				@click.native="validateKeycard"
				:loading="loading"
				size="small"
				class="cart-card-fast-checkout__button"
			>
				<!-- {{ $t('newaccount.updateGuest') }} -->
				Validera keycardnummer
			</Button>

			<!-- Key number success text -->
			<p>
				<span v-if="showKeycardSuccess" class="">Grattis!</span>
				{{ $t('cart.existingKeycardInfo') }}
			</p>
		</template>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'
import '../../utilities/helper.js'

import Select from '../atoms/Select'
import InputComponent from '../atoms/InputComponent'
import Button from '../atoms/Button'
import ScanKeycard from '../../components/molecules/ScanKeycard'

export default {
	name: 'CartCardFastCheckout',
	store,
	mixins: [mixin],
	components: {
		Select,
		InputComponent,
		Button,
		ScanKeycard
	},
	data() {
		return {
			showNewKeycard: true,
			showExistingKeycard: false,
			showKeycardError: false,
			showKeycardSuccess: false,
			loading: false,
			keynumber: '',
			showKeycardScan: false,
			showKeycardScanError: false
		}
	},
	props: {
		product: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		cart() {
			return store.state.cart
		}
	},
	methods: {
		onChangeKeycardType(val) {
			this.showKeycardScan = false
			this.showKeycardScanError = false

			//New kaycard
			if (val == 'new') {
				this.showNewKeycard = true
				this.showExistingKeycard = false

			//Existing keycard
			} else if (val == 'existing') {
				this.showExistingKeycard = true
				this.showNewKeycard = false
			}

			this.showKeycardSuccess = false
			this.showKeycardError = false

			this.addOrUpdateKeycard('')
			this.keynumber = ''
		},
		validateKeycard() {
			this.showKeycardScan = false
			// this.showKeycardSuccess = false
			// this.showKeycardError = false
			this.showKeycardScanError = false

			// if (this.validate()) {
			//store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
			//if (response) {
			if (this.keynumber == '') {
				//sätt keynumber på produkten i cart till ''
				this.addOrUpdateKeycard('')
				this.showKeycardSuccess = false
				this.showKeycardError = true
			} else {
				this.loading = true
				this.showKeycardSuccess = false
				this.showKeycardError = false
				store
					.dispatch('GET_KEY_CARD_VALIDATION', this.keynumber)
					.then(success => {
						if (success.length && success[0].valid) {
							this.loading = false
							this.showKeycardSuccess = true
							//sätt keynumber på produkten i cart till this.keynumber
							this.addOrUpdateKeycard(this.keynumber)
						} else {
							this.loading = false
							this.showKeycardError = true
						}
					})
					.catch(function (error) {
						window.error(error)
						this.loading = false
					})
			}
			//} else {
			//this.loading = false
			//}
			//})
			// } else if (this.guest.keynumber != '' && this.keycardValid == false) {
			// 	this.showKeycardError = true
			// }
		},
		addOrUpdateKeycard(val) {
			this.loading = true
			this.showKeycardScan = false
			store
				.dispatch('GET_CART_SKIPASS_KEYCARD', {
					value: val,
					uniqueId: this.product.uniqueId
				})
				.then(success => {
					if (success) {
						this.showSuccess = true
					}
					this.loading = false
					//this.cart.skischool = store.state.cart.skischool
				})
				.catch(function (error) {
					window.console.error(error)
					this.loading = false
				})
		},

		onKeycardScanned(val) {
			//console.log('onKeycardScanned', val)
			// this.keynumber = val
			// this.showKeycardScan = false
			//console.log('onKeycardScanned', val)
			this.keynumber = val
			this.showKeycardScan = false
			if (val == '') {
				this.showKeycardScanError = true
			} else {
				this.showKeycardScanError = false
				this.$refs.keycardInputComponent.focus();
				//create-guest-form__keycard
			}
			//this.retry()
		}
	}
}
</script>

<style lang="scss" scoped>
.cart-card-fast-checkout {
	&__select {
		margin-bottom: 20px;
	}

	&__button {
		margin-bottom: 20px;
	}

	.error {
		color: $colorRed;
		margin: -15px 0 20px;
	}

	&__input {
		display: inline-block;
		width: calc(100% - 50px);
	}

	.keycard-scanner {
		margin-bottom: 20px;
	}

	&__keycard-scan {
		display: inline-block;
		background:none;
        border: none;
        cursor: pointer;
		vertical-align: sub;

		border-radius: 3px;
		background: #04BEFB;

		margin-left: 10px;
		padding: 10px 10px 10px 10px;
		margin-top: -4px;

		.icon {
			display: block;
			width: 20px;
			height: 20px;
			fill: #fff;
		}

		&.--active {
			background: #546482;
		}
	}

	&__keycard {
		display: inline-block;
		width: calc(100% - 50px);
		max-width: 290px;
	}

	.keycard-error {
		width: 100%;
		color: $colorRed;
		position: relative;
		top: -15px;
		color: #e15b5b;
		display: inline-block;
		font-size: 10px;
		line-height: 15px;
	}
}
</style>
